import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import { useState, useRef } from 'react';

function TimeDetail({ programCode }) {
  const apiUrl = process.env.REACT_APP_API_DOMAIN + `yeonoo/main-table/time?programCode=${programCode}`;
  const dataSource = {
    api: {
      readData: { url: apiUrl, method: 'GET' }
    }
  };

  const columnArray = [
    { name: 'receive_time', header: programCode, align: 'center', width: 250 },
  ];
  const gridReference = useRef(); // 그리드 참조
  
  const [grid, setGrid] = useState(
    <Grid
      ref={gridReference} //그리드 참조
      width={'100%'}
      bodyHeight={'auto'}
      minBodyHeight={0}
      data={dataSource}
      columns={columnArray}
      onResponse={OnResponse} //서버 응답
      scrollX={false}
      scrollY={false}
    />
  );

  function OnResponse(event) {
    const response = JSON.parse(event.xhr.response);

    if (!response.result) {
      alert(`(${response.apiUrl}) ${response.apiMethod} API 실패\n${response.message}`);
    }
  }

  return grid;
}

export default TimeDetail;
